/* eslint-disable no-param-reassign,no-underscore-dangle,@typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../../app/constants/events';
import { loadSelectPickerItems } from '../../../../app/common/store/select-picker.actions';
import { queryParamsMap } from '../../../../app/common/components/forms/select-picker/select-picker-types.enum';
import { connectionIconUrlByType } from '../../../../app/common/helper/connection-icon-url-by-type.helper';

xplenty.controller('ComponentEditorExecuteSqlController', [
  '$scope',
  '$rootScope',
  '$timeout',
  '$controller',
  'selectPickerModal',
  'ngrxStoreService',

  function ($scope, $rootScope, $timeout, $controller, selectPickerModal, ngrxStoreService) {
    angular.extend(this, $controller('WorkflowOperatorStep', { $scope }));
    $scope.hasComponentChanged = 0;

    $scope.connection = $scope.component.connection || null;
    $scope.connectionQuery = {
      type: $scope.component.connectionTypes,
    };
    $scope.connectionTypes = $scope.component.connectionTypes.split(',');
    $scope.selectConnection = (connection) => {
      $scope.connection = connection;
      $scope.component.connection = connection;
    };

    $scope.onCreateNewConnection = ({ connection, type }) => {
      selectPickerModal.createNew(connection, type, 'connection-picker-sql-editor');

      const subscriber = $rootScope.$on(EVENTS.CONNECTION_CREATED, (event, connectionItem) => {
        ngrxStoreService.dispatch(
          loadSelectPickerItems({
            id: 'connection-picker-sql-editor',
            itemType: type,
            params: { ...queryParamsMap[type], ...$scope.connectionQuery },
          }),
        );
        $scope.selectConnection(connectionItem);
        subscriber();
      });
    };

    $scope.connectionStep = $scope.$parent.createStep(
      'Query connection',
      'Choose input connection',
      `<xp-select-picker-editable
                          id="connection-picker-sql-editor"
            type="connection"
            [value]="connection"
            placeholder="Select connection"
            empty-placeholder="Connections list is empty"
            on-value-change="selectConnection($event)"
            on-create-new="onCreateNewConnection($event)"
            [params]="connectionQuery"
            bind-connection-types="connectionTypes"
          ></xp-select-picker-editable>`,
    );
    $scope.componentFormStep = $scope.$parent.createStep(
      'Query',
      'Define your query',
      $scope.component.editorDirective,
    );

    $scope.componentUpdate = function (component) {
      $scope.component.dynamic_connection = component.dynamic_connection;
    };

    const setRelevantStep = function () {
      if (!$scope.component.connection || !$scope.component.connection.id) {
        $scope.connectionStep.active = true;
      }
    };

    $timeout(setRelevantStep);

    $scope.componentFormStep.valid = false;

    $scope.$watch(
      'connection',
      function (newConnection, oldConnection) {
        if (newConnection.id !== oldConnection.id) {
          $scope.hasComponentChanged += 1;
        }

        if (newConnection && newConnection.id) {
          $scope.connectionStep.valid = true;

          const img = `<img class="tag-icon" src="${connectionIconUrlByType(newConnection.type)}" alt="${
            newConnection.name
          }"/>`;
          $scope.connectionStep.tags = [
            {
              icon: '',
              name: `${img}<b>${_.escape(newConnection.name)}</b>`,
            },
          ];
        } else {
          $scope.connectionStep.valid = false;
          $scope.connectionStep.tags = [];
        }
      },
      true,
    );

    const getValueName = function (key, value) {
      const $label = angular.element(`[for="${key}"]`);
      const $next = $label.next();
      if ($next.is('.btn-group-select')) {
        value = $next.find(`[value="${value}"]`).text();
      } else if ($next.is('select')) {
        value = $next.find('option:selected').text();
      }
      return value;
    };

    let componentNameValid = false;

    $rootScope.$on(EVENTS.DESIGNER_COMPONENT_NAME_VALID, function (event, valid) {
      componentNameValid = valid;
    });

    $scope.$watch(
      'component',
      function (newComponent, oldComponent) {
        if (newComponent && newComponent.name !== oldComponent.name) {
          $scope.hasComponentChanged += 1;
        }
        const valid = $scope.$parent._default.valid(newComponent);

        $scope.componentFormStep.valid = valid;

        if (valid) {
          $scope.componentFormStep.tags = [
            {
              name: `<b>Query:</b> ${_.escape(newComponent.query)}`,
            },
            {
              name: `<b>Result type:</b> ${getValueName('result_type', newComponent.result_type)}`,
            },
          ];
        } else {
          $scope.componentFormStep.tags = [];
        }

        if (newComponent.dynamic_connection) {
          if (!$scope.connectionStep.tags.find((tag) => tag.name === $scope.component.dynamic_connection)) {
            $scope.connectionStep.tags = [
              ...$scope.connectionStep.tags,
              {
                name: $scope.component.dynamic_connection,
              },
            ];
          }
        } else {
          $scope.connectionStep.tags = $scope.connectionStep.tags.filter(
            (tag) => tag.name !== $scope.component.dynamic_connection,
          );
        }

        $timeout(function () {
          const saveDisabled = !(componentNameValid && $scope.connectionStep.valid && $scope.componentFormStep.valid);
          $rootScope.$broadcast(EVENTS.DESIGNER_COMPONENT_SAVE_DISABLE, saveDisabled);
        });
      },
      true,
    );
  },
]);
